/**
 * Created by Michele Romani on 27/06/2017.
 */
(function() {
    'use strict';

    angular
        .module('gestioneAttiApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('pdlForm', {
            parent: 'app',
            url: '/pdlForm',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/layouts/form/form.html',
                    controller: 'FormController',
                    controllerAs: 'vm'
                }
            },
            params: {
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    $translatePartialLoader.addPart('form');
                    $translatePartialLoader.addPart('atto');
                    $translatePartialLoader.addPart('tipoAtto');
                    return $translate.refresh();
                }]
            }
        });
    }
})();
